import { Link } from 'react-router-dom';

export default function FeatureCards() {
  return (
    <section className="py-16 md:py-24 bg-background-50 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
            OOPBuy Spreadsheet Guides
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Everything you need to know about using the OOPBuy spreadsheet system for smarter shopping.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          <Link
            to="/oopbuy-spreadsheet-guide"
            className="group relative h-80 md:h-96 rounded-2xl overflow-hidden cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%20with%20a%20laptop%20displaying%20a%20spreadsheet%20on%20a%20warm%20wooden%20desk%2C%20soft%20natural%20light%20streaming%20through%20a%20window%2C%20a%20ceramic%20coffee%20cup%20nearby%2C%20editorial%20photography%2C%20warm%20earthy%20tones%2C%20no%20text%20no%20logos%2C%20clean%20minimalist%20composition&width=600&height=800&seq=feat-whatis-v3&orientation=portrait"
              alt="What is OOPBuy Spreadsheet"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
              <h3 className="text-lg md:text-xl font-heading font-semibold text-white mb-2">
                What is OOPBuy Spreadsheet?
              </h3>
              <p className="text-sm text-white/80 leading-relaxed line-clamp-2">
                Learn how the OOPBuy spreadsheet system works and why thousands of smart shoppers use it every day.
              </p>
            </div>
          </Link>

          <Link
            to="/article/oopbuy-spreadsheet-shoes-guide"
            className="group relative h-80 md:h-96 rounded-2xl overflow-hidden cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20a%20tablet%20displaying%20a%20shopping%20list%20surrounded%20by%20fashion%20items%20including%20a%20watch%20sunglasses%20and%20a%20leather%20wallet%20on%20a%20warm%20beige%20linen%20surface%2C%20soft%20natural%20studio%20lighting%2C%20editorial%20minimalist%20style%2C%20no%20text%20no%20logos%2C%20warm%20neutral%20tones&width=600&height=800&seq=feat-howto-v3&orientation=portrait"
              alt="How to Use OOPBuy Guide"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
              <h3 className="text-lg md:text-xl font-heading font-semibold text-white mb-2">
                Shoes Shopping Guide
              </h3>
              <p className="text-sm text-white/80 leading-relaxed line-clamp-2">
                Find the best sneaker deals with price comparison, ratings, and real-time availability tracking.
              </p>
            </div>
          </Link>

          <Link
            to="/article/oopbuy-spreadsheet-bags-guide"
            className="group relative h-80 md:h-96 rounded-2xl overflow-hidden cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20tan%20leather%20handbag%20and%20a%20beige%20canvas%20tote%20placed%20side%20by%20side%20on%20a%20warm%20cream%20surface%20for%20comparison%2C%20soft%20natural%20studio%20lighting%2C%20editorial%20minimalist%20photography%2C%20no%20text%20no%20logos%2C%20clean%20refined%20composition%2C%20neutral%20warm%20tones&width=600&height=800&seq=feat-compare-v3&orientation=portrait"
              alt="Bags Shopping Comparison"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
              <h3 className="text-lg md:text-xl font-heading font-semibold text-white mb-2">
                Bags Shopping Guide
              </h3>
              <p className="text-sm text-white/80 leading-relaxed line-clamp-2">
                Discover the best bag deals with curated listings, price comparison, and weekly fresh updates.
              </p>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}